import {useNavigate, useParams} from "react-router";
import { useApp } from "../Context";

export default function ProfileDropdown() {
    const navigate = useNavigate();
    const {restaurant} = useParams();
    const {auth, setAuth} = useApp();
    return (
        <div className="dropdown">
            {/* Profile Icon - Opens Dropdown */}
            <button
                className="btn border-0 bg-transparent p-0"
                type="button"
                id="profileDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <i className="bi bi-person-circle fs-4 text-dark" style={{ cursor: "pointer" }}></i>
            </button>

           {/* Dropdown Menu */}
            <ul className="dropdown-menu dropdown-menu-end shadow-sm" aria-labelledby="profileDropdown">
                {auth ? (
                    <>
                        <li onClick={() => navigate("profile")}>
                            <a className="dropdown-item">Profil</a>
                        </li>
                        
                        <li
                            onClick={() => {
                                navigate(`/${restaurant}/order`);
                                setTimeout(() => setAuth(null), 100);
                            }}
                        >
                            <a className="dropdown-item text-danger fw-semibold">Logga ut</a>
                        </li>
                    </>
                ) : (
                    <li onClick={() => navigate("profile/login")}>
                        <a className="dropdown-item fw-semibold">Logga in</a>
                    </li>
                )}
            </ul>

        </div>
    );
}
